export default __webpack_public_path__ + "static/app-store-9a6c0536e06ceb1923caddbe406d6bab.svg";